(function () {
  function setLayer(panel, index) {
    if (!panel || !index) return;

    var detail = panel.querySelector('[data-materials-mobile-detail]');
    var items = panel.querySelectorAll('[data-acc-item]');
    var progressBtns = panel.querySelectorAll('[data-progress-btn]');
    var hotspots = panel.querySelectorAll('[data-hotspot]');
    var activeItem = null;

    items.forEach(function (item) {
      var match = item.getAttribute('data-layer-index') === String(index);
      var btn = item.querySelector('[data-acc-btn]');
      item.classList.toggle('is-open', match);
      if (btn) btn.setAttribute('aria-expanded', match ? 'true' : 'false');
      if (match) activeItem = item;
    });

    progressBtns.forEach(function (btn) {
      var match = btn.getAttribute('data-layer-index') === String(index);
      btn.classList.toggle('is-active', match);
      btn.setAttribute('aria-selected', match ? 'true' : 'false');
    });

    hotspots.forEach(function (spot) {
      var match = spot.getAttribute('data-layer-index') === String(index);
      spot.classList.toggle('is-active', match);
      spot.setAttribute('aria-pressed', match ? 'true' : 'false');
    });

    if (detail && activeItem) {
      var titleEl = detail.querySelector('[data-mobile-title]');
      var textEl = detail.querySelector('[data-mobile-text]');
      var title = activeItem.getAttribute('data-layer-title') || '';
      var text = activeItem.getAttribute('data-layer-text') || '';
      if (titleEl) titleEl.textContent = title;
      if (textEl) textEl.textContent = text;
    }

    panel.setAttribute('data-open-layer', String(index));
  }

  function initPanel(panel) {
    var openLayer = panel.getAttribute('data-open-layer') || '1';
    setLayer(panel, openLayer);

    panel.querySelectorAll('[data-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-acc-item]');
        if (!item) return;
        setLayer(panel, item.getAttribute('data-layer-index'));
      });
    });

    panel.querySelectorAll('[data-progress-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setLayer(panel, btn.getAttribute('data-layer-index'));
      });
    });

    panel.querySelectorAll('[data-hotspot]').forEach(function (spot) {
      spot.addEventListener('click', function () {
        setLayer(panel, spot.getAttribute('data-layer-index'));
      });
    });
  }

  function initMaterials(root) {
    var tabs = root.querySelectorAll('[data-materials-tab]');
    var panels = root.querySelectorAll('[data-materials-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach(function (tab) {
        var selected = tab.getAttribute('data-materials-tab') === id;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var selected = panel.getAttribute('data-materials-panel') === id;
        panel.classList.toggle('is-active', selected);
        if (selected) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-materials-tab'));
      });
    });

    panels.forEach(initPanel);
  }

  function initAll() {
    document.querySelectorAll('[data-topper-materials]').forEach(initMaterials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-topper-materials]');
    if (root) initMaterials(root);
  });
})();
